<mat-form-field appearance="outline">
    <mat-label>{{ label }}</mat-label>
    <input
        type="text"
        matInput
        [placeholder]="placeholder"
        [formControl]="searchControl"
        [matAutocomplete]="auto"
        (blur)="onBlur()"
    />

    <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayFn"
        (optionSelected)="onSelect($event.option.value)"
    >
        <mat-option *ngFor="let item of items" [value]="item">
            {{ displayFnFn(item) }}
        </mat-option>

        <mat-option *ngIf="loading" disabled>
            <div style="display: flex; align-items: center; gap: 8px">
                <mat-spinner diameter="20" strokeWidth="3"></mat-spinner>
                Cargando...
            </div>
        </mat-option>

        <mat-option *ngIf="noResults()" disabled> Sin resultados </mat-option>
    </mat-autocomplete>
</mat-form-field>
